import { Button } from '@creditornot/cb-button';
import { Typography as T } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import HighFiveHands from 'common/illustrations/HighFiveHands';

import { CenteredContent, Heading, IllustrationContainer, TextStack } from '../ComplianceContent';
import { BREAKPOINT_MOBILE } from '../breakpoints';

const StyledBody = styled(T.Body1)`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 600px;
`;

const StyledButton = styled(Button)`
  width: 100%;

  @media (min-width: ${BREAKPOINT_MOBILE}px) {
    max-width: 200px;
  }
`;

type Keys = {
  heading: string;
  body: string;
  button: string;
};

const BusinessVerificationSuccess = () => {
  const history = useHistory();

  const handleContinue = () => {
    history.push('/');
  };

  const keys: Keys = {
    heading: 'compliance.kyb.success.thank-you',
    body: 'compliance.kyb.success.body',
    button: 'compliance.kyb.success.back-to-front-page',
  };

  return (
    <CenteredContent>
      <IllustrationContainer>
        <HighFiveHands height="100%" />
      </IllustrationContainer>

      <TextStack>
        <Heading>
          <FormattedMessage id={keys.heading} />
        </Heading>
        <StyledBody>
          <div>
            <FormattedMessage id={keys.body} />
          </div>
        </StyledBody>
      </TextStack>

      <StyledButton size="large" variant="blue" onClick={handleContinue}>
        <FormattedMessage id={keys.button} />
      </StyledButton>
    </CenteredContent>
  );
};

export default BusinessVerificationSuccess;
